var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "footer-section" }, [
    _c(
      "div",
      { staticClass: "upper-footer-region" },
      [
        _c("b-container", [
          _c(
            "div",
            { staticClass: "footer-region-divider" },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-md-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [_c("page-element-footer-logo")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "middle-footer-region" },
      [
        _c("b-container", [
          _c(
            "div",
            { staticClass: "footer-region-divider" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents("footer-link-list-1"),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "footer-link-list-1",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("footer-link-list-1", data),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents("footer-link-list-2"),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "footer-link-list-2",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("footer-link-list-2", data),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents("footer-link-list-3"),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "footer-link-list-3",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("footer-link-list-3", data),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "lower-footer-region" },
      [
        _c("b-container", [
          _c(
            "div",
            { staticClass: "footer-region-divider" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("content-creator", {
                        staticClass: "footer-terms",
                        attrs: {
                          settings: _vm.getBlobContents("footer-terms"),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "footer-terms",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("footer-terms", data),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("footer-social", {
                        attrs: {
                          "social-alignment": _vm.socialAlignment,
                          "social-branding": _vm.socialBranding,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "disclaimer-footer-region" },
      [
        _c(
          "b-container",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c("content-creator", {
                      attrs: {
                        settings: _vm.getBlobContents("footer-disclaimer"),
                        permissions: _vm.contentCreatorPermissions,
                        "is-visible": _vm.editContentCreator,
                        filestore: _vm.fileStore,
                        name: "footer-disclaimer",
                        "allowed-widgets":
                          "wysiwyg-editor, advanced-wysiwyg-editor",
                      },
                      on: {
                        updateBlob: (data) =>
                          _vm.saveBlob("footer-disclaimer", data),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "software-provider-footer-region" },
      [
        _c(
          "b-container",
          [
            _c(
              "b-row",
              { staticClass: "justify-content-center" },
              [_c("b-col", [_c(_vm.copyright, { tag: "component" })], 1)],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }